// src/types/housekeeping/HousekeepingRefusal.ts
var HousekeepingRefusal = /* @__PURE__ */ ((HousekeepingRefusal2) => {
  HousekeepingRefusal2["RoomNotFound"] = "ROOM_NOT_FOUND";
  HousekeepingRefusal2["InvalidTransition"] = "HOUSEKEEPING_INVALID_TRANSITION";
  HousekeepingRefusal2["AssigneeNotAMember"] = "ASSIGNEE_NOT_A_MEMBER";
  return HousekeepingRefusal2;
})(HousekeepingRefusal || {});

export {
  HousekeepingRefusal
};
